$(function() {
  initBrandFilter();
});

function initBrandFilter() {
  // Filter using navigation
  $(".brand-nav-item a").click(function() {
    var nav = $(this).attr("data-nav");


    // Remove & Add active class
    $(".brand-nav-item").removeClass("active");
    $(this)
      .parent()
      .toggleClass("active");

    // Hide all the results
    $(".brand-results-row").addClass("inactive");


    // Loop through the row
    $(".brand-results-row").each(function() {
      var term = $(this).attr("data-term");

      if (nav == term) {
        $(this).removeClass("inactive");
      }
    });

    // Only return false if data-toggle is brand
    if ($(this).attr("data-toggle") == "brand") {
      return false;
    }
  
    });
}

$window = $(window);
$window.scroll(function() {
  $scroll_position = $window.scrollTop();
    if ($scroll_position > 300) { // if body is scrolled down by 300 pixels
        $('.main-nav__wrapper').addClass('sticky');
        
        // to get rid of jerk
        header_height = $('.main-nav__wrapper').innerHeight();
        $('body').css('padding-top' , header_height);
    } else {
        $('body').css('padding-top' , '0');
        $('.main-nav__wrapper').removeClass('sticky');
    }
 });

$window = $(window);
$window.scroll(function() {
  $scroll_position = $window.scrollTop();
    if ($scroll_position > 300) { // if body is scrolled down by 300 pixels
        $('#header .top-bar').addClass('sticky');
        
        // to get rid of jerk
        header_height = $('#header .top-barr').innerHeight();
        $('body').css('padding-top' , header_height);
    } else {
        $('body').css('padding-top' , '0');
        $('#header .top-bar').removeClass('sticky');
    }
 });
 

jQuery(function($){
   
    $('.main-carousel').flickity({
  		// options
  		wrapAround: true,
      pageDots: false,
      initialIndex: 1,
      fade: true,
      watchCSS: true,
      prevNextButtons: false,
      accessibility: true, //true by default
      autoPlay: true // advance cells every 3 seconds
    });
  });

